<template>
  <div class="main">
    <Header
      :show="true"
      title="开罐审核"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="请仔细检测核对后再行开启罐口"
      />
      <van-form ref="update" @submit="submit">
        <van-field
          v-model.trim="listQuery.plateNumber"
          label="车牌号"
          placeholder="请输入车牌号"
          readonly
        />
        <van-field
          :value="listQuery.material"
          label="物料名称"
          placeholder="点击选择物料名称"
          readonly
        />
        <van-field
          v-model.trim="listQuery.supplier"
          label="供应商"
          placeholder="请输入供应商"
          readonly
        />
        <van-field name="凭证照片" label="凭证照片">
          <template #input>
            <van-image width="5rem" height="5rem" :src="listQuery.applyPhoto">
            </van-image>
          </template>
        </van-field>
        <van-field
          v-model="listQuery.remark"
          rows="2"
          autosize
          label="备注"
          type="textarea"
          maxlength="100"
          placeholder="无"
          show-word-limit
          readonly
        />
        <van-field
          v-model.trim="listQuery.portName"
          label="推荐罐口"
          placeholder="未知罐口"
          readonly
        />
        <van-field
          clickable
          name="picker"
          :value="listQuery.reMaterial"
          label="物料确认"
          placeholder="请选择物料"
          required
          @click="material.show = true"
          :rules="[{ validator: validMaterialName, message: '' }]"
        />
        <van-popup v-model="material.show" position="bottom">
          <van-picker
            show-toolbar
            :columns="material.columns"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
        </van-popup>
        <van-field
          clickable
          name="picker"
          :value="listQuery.rePort"
          label="卸料罐口"
          placeholder="请选择卸料罐口"
          required
          @click="port.show = true"
          :rules="[{ validator: validPort, message: '' }]"
        />
        <van-popup v-model="port.show" position="bottom">
          <van-picker
            show-toolbar
            :columns="port.columns"
            @confirm="handlePickerPort"
            @cancel="port.show = false"
          />
        </van-popup>
        <!-- <van-field
        label="注意"
        placeholder="非常重要，务必重视"
        :error="true"
        readonly
      /> -->
        <van-field
          v-if="listQuery.isNeedPhoto === 'true'"
          name="质检照片"
          label="质检照片"
          required
          :rules="[{ validator: validPhoto, message: '请上传照片' }]"
        >
          <template #input>
            <van-uploader
              v-model="listQuery.qcPhoto"
              :max-count="1"
              capture="camera"
              :before-read="beforeRead"
              :after-read="afterRead"
              :before-delete="beforeDelete"
            />
            <div style="color: #ff4040">非常重要，务必重视</div>
          </template>
        </van-field>
        <van-field label="操作" required>
          <template #input>
            <van-radio-group v-model="listQuery.status" direction="horizontal">
              <van-radio :name="1">同意</van-radio>
              <van-radio :name="2">拒绝</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="listQuery.status === 2"
          ref="reason"
          v-model="listQuery.rejectReason"
          rows="2"
          autosize
          label="原因"
          type="textarea"
          maxlength="100"
          placeholder="请输入拒绝原因"
          show-word-limit
          required
          :rules="[{ validator: validSupplierName, message: '' }]"
        />
        <div style="margin: 0.6rem 1rem" v-if="checkPermission([32])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <van-dialog
      v-model="dialogVisibleOpenSuccess"
      title="查询罐口开启状态"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :before-close="ListenBeforeCloseIntercept"
    >
      <van-field label="操作" required>
        <template #input>
          <van-radio-group v-model="listQuery.verify" direction="horizontal">
            <van-radio :name="0">同意</van-radio>
            <van-radio :name="1">拒绝</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-if="listQuery.verify === 1"
        ref="reason"
        v-model="listQuery.reason"
        rows="1"
        autosize
        label="原因"
        type="textarea"
        maxlength="100"
        placeholder="请输入拒绝原因"
        show-word-limit
        required
      />
    </van-dialog>

    <van-dialog
      v-model="dialogVisibleUpdate"
      title="确认开启罐口？"
      show-cancel-button
      :before-close="handleClickUpdateConfirm"
    >
      <van-form
        style="line-height: 1.5em; padding: 15px 10px; text-align: center"
      >
        <div style="color: #f56c6c" v-if="listQuery.using === true">
          注意：该罐口目前正在使用中...
        </div>
        <div style="color: #aaa">司机申请开启罐口</div>
        <div
          :style="
            listQuery.portName === listQuery.rePort &&
            listQuery.material === listQuery.reMaterial
              ? 'color: #67C23A'
              : 'color: #E6A23C'
          "
        >
          {{ listQuery.material }} - {{ listQuery.portName }} -
          {{ listQuery.plateNumber }}
        </div>
        <div style="color: #aaa">您授权开启罐口</div>
        <div
          :style="
            listQuery.portName === listQuery.rePort &&
            listQuery.material === listQuery.reMaterial
              ? 'color: #67C23A'
              : 'color: #E6A23C'
          "
        >
          {{ listQuery.reMaterial }} - {{ listQuery.rePort }} -
          {{ listQuery.plateNumber }}
        </div>
      </van-form>
    </van-dialog>
    <Footer value="service" />
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { parseTime } from "@/utils";
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { validPlateNumber, isName } from "@/utils/validate";
import { getConfigList as getPortList } from "@/api/port.js";
import {
  getList as getMaterialList,
  updateMaterialCheckOne as updateOne,
} from "@/api/material.js";
import { getList as getProjectSwitchList } from "@/api/switch.js";

export default {
  name: "ServiceBussinessMaterialUpdate",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      baseUrl: "",
      isLoading: false,
      loading: false,
      dialogVisibleUpdate: false,
      dialogVisibleOpenSuccess: false,
      listQuery: {
        plateNumber: "",
        material: "",
        supplier: "",
        applyPhoto: "",
        serial: 1,
        port: "",
        portName: "未知罐口",
        rePort: "",
        reMaterial: "",
        sampling: false,
        file: null,
        qcPhoto: [],
        status: 1,
        rejectReason: "",
        using: false,
      },
      do: true,
      temp: null,
      material: {
        show: false,
        columns: [],
      },
      port: {
        show: false,
        columns: [],
        options: [],
      },
      lastTime: new Date().getTime(),
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    const url = window.location.href;
    this.baseUrl = url.substr(0, url.indexOf("/sywnq")) + "/sywnq";

    const row = this.$route.query;
    this.listQuery = row;
    this.listQuery.serial = row.serial;
    this.listQuery.plateNumber = row.plateNumber;
    this.listQuery.material = row.material;
    this.listQuery.supplier = row.supplier;
    this.listQuery.applyPhoto = row.applyUrl;
    // this.listQuery.port = row.port
    this.listQuery.portName = row.port;
    this.listQuery.isNeedPhoto = row.isNeedPhoto;
    this.listQuery.status = row.status;

    console.log(this.listQuery);

    this.handleGetPortList();
    this.handleGetMaterialList();
    // this.handleGetProjectSwitchList()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    handleClickRight() {
      this.$refs.update.submit();
    },
    submit() {
      if (this.listQuery.reMaterial.replace(/(^\s*)|(\s*$)/g, "") === "") {
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          300,
          "罐口开启",
          "请先确认物料"
        );
        return;
      }
      if (
        this.listQuery.isNeedPhoto === "true" &&
        this.listQuery.qcPhoto.len === 0
      ) {
        showPhoneAlarm(true, "toast", null, 2000, 300, "罐口开启", "请先拍照");
        return;
      }
      const rePort = this.portNameToId(this.listQuery.rePort);
      let data = new FormData();
      data.append("id", this.listQuery.serial);
      data.append("materialName", this.listQuery.reMaterial);
      data.append("port", rePort);
      data.append("sampling", this.listQuery.isNeedPhoto);
      if (this.listQuery.isNeedPhoto === "true") {
        data.append("samplingImage", this.listQuery.file);
      }
      data.append("supplierName", this.listQuery.supplier);
      data.append("plateNumber", this.listQuery.plateNumber);
      data.append("status", this.listQuery.status);
      data.append("rejectReason", this.listQuery.rejectReason);
      this.temp = data;
      console.log(this.listQuery);
      console.log(this.temp);
      if (this.listQuery.status === 2) {
        if (this.listQuery.rejectReason.replace(/(^\s*)|(\s*$)/g, "") === "") {
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            300,
            "罐口开启",
            "拒绝请输入原因"
          );
          return;
        }
        Dialog.confirm({
          title: "拒绝开启罐口？",
          message: "拒绝理由：" + this.listQuery.rejectReason,
          // theme: 'round-button'
        })
          .then(() => {
            this.loading = true;
            updateOne(data)
              .then((response) => {
                const { data } = response;
                if (
                  showPhoneAlarm(
                    true,
                    "toast",
                    null,
                    2000,
                    data.code,
                    "拒绝开启罐口",
                    data.message
                  )
                ) {
                  this.$router.push({
                    path: "/service/business/material-",
                    query: {},
                  });
                }
                this.loading = false;
              })
              .catch(function (error) {
                this.loading = false;
                console.error(error);
              });
          })
          .catch(() => {
            showPhoneAlarm(
              true,
              "toast",
              "success",
              2000,
              200,
              "拒绝开启罐口",
              "取消"
            );
          });
      } else {
        const nowTime = new Date().getTime();
        if (nowTime - this.lastTime < 60) {
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            300,
            "罐口开启",
            "请1分钟后再进行操作"
          );
          return;
        }
        this.dialogVisibleUpdate = true;
        if (
          this.listQuery.portName === "" ||
          this.listQuery.portName === null
        ) {
          this.listQuery.portName = "未知罐口";
        }
        for (let i = 0; i < this.port.options.length; i++) {
          if (this.listQuery.rePort === this.port.options[i].name) {
            this.listQuery.using = this.port.options[i].using;
          }
        }
      }
    },
    handleClickUpdateConfirm(action, done) {
      if (action === "confirm") {
        this.lastTime = new Date().getTime();
        this.loading = true;
        updateOne(this.temp)
          .then((response) => {
            const { data } = response;
            this.loading = false;
            done(true);
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "开启罐口",
                data.message
              )
            ) {
              // this.dialogVisibleOpenSuccess = true
              this.$router.push({
                path: "/service/business/material",
                query: {},
              });
            }
          })
          .catch(function (error) {
            this.loading = false;
            done(true);
            console.error(error);
          });
      } else {
        showPhoneAlarm(true, "toast", "success", 2000, 200, null, "取消审核");
        done(true);
      }
    },
    ListenBeforeCloseIntercept(action, done) {
      console.log("侦听开罐结果");
      setTimeout(done, 10000);
    },
    beforeRead(file) {
      if (file.type !== "image/jpeg") {
        showPhoneAlarm(
          true,
          "toast",
          "success",
          2000,
          200,
          "图片上传",
          "请上传 jpg 格式图片"
        );
        return false;
      }
      return true;
    },
    afterRead(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          this.listQuery.file = file.file;
          resolve(file);
        }
        const scale = parseFloat(
          1 / (file.file.size / 1024 / 1024 / 0.2)
        ).toFixed(2);
        imageConversion
          .compressAccurately(file.file, {
            size: 200,
            // scale: scale,
            width: 640,
          })
          .then((res) => {
            this.listQuery.file = res;
            resolve(res);
          });
      });
    },
    beforeDelete(file) {
      this.listQuery.file = null;
      return true;
    },
    handlePickerPort(value) {
      console.log(value);
      this.listQuery.rePort = value;
      this.port.show = false;
    },
    handleMaterialSelect(value) {
      this.listQuery.reMaterial = value;
      this.material.show = false;
    },
    portNameToId(value) {
      const len = this.port.options.length;
      for (let i = 0; i < len; i++) {
        if (this.port.options[i].name === value) {
          return this.port.options[i].id;
        }
      }
      return null;
    },
    handleGetMaterialList() {
      const data = {
        page: 1,
        limit: 10000,
      };
      getMaterialList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.material.columns = [];
            for (let i = 0; i < items.length; i++) {
              if (items[i].type === 2)
                this.material.columns.push(items[i].name);
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetPortList() {
      const data = {};
      getPortList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            this.port.columns = [];
            for (let i = 0; i < items.length; i++) {
              this.port.columns.push(items[i].portName);
              this.port.options.push({
                id: items[i].id,
                name: items[i].portName,
                using: items[i].using,
              });
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetProjectSwitchList() {
      const data = {};
      getProjectSwitchList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data;
            for (let i = 0; i < items.length; i++) {
              if (
                items[i].type === "生产开关" &&
                items[i].name === "粉料检测采样"
              ) {
                if (items[i].value === "关闭") {
                  this.do = false;
                } else {
                  this.do = true;
                }
              }
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-field__control:read-only {
  color: #999;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
